<template>
  <generic-modal :title="$t('execute')" ref="generic_modal" size="fullscreen">
    <div>
      <div id="component_wrapper"></div>
    </div>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("close") }}</span>
      </button>
    </template>
  </generic-modal>
</template>

<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
  format_currency,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import { createApp } from "vue/dist/vue.esm-bundler.js";
import mitt from "mitt";
const emitter = mitt();

export default {
  name: "ExecuteModal",
  components: { GenericModal },
  data() {
    return {
      error: "",
      component_data: {},
      dynamic_component: null,
    };
  },
  methods: {
    close_modal() {
      this.set_initial_state();
      this.$refs.generic_modal.close_modal();
    },
    show_modal(data) {
      this.set_initial_state();
      this.$refs.generic_modal.show_modal();
      this.component_data = data;
      let code = data.code;
      if (code && code.html && code.js && code.css)
        this.create_dynamic_component(code.html, code.js, code.css);
    },
    set_initial_state() {
      let v = this;
      v.component_data = {};
      if (v.dynamic_component && v.dynamic_component.unmount) {
        v.dynamic_component.unmount();
      }
      v.error = "";
    },
    create_dynamic_component(html, js, css) {
      try {
        if (this.dynamic_component && this.dynamic_component.unmount)
          this.dynamic_component.unmount();

        // Evaluar el código JavaScript en un contexto de función
        const script = new Function(
          "return " + js.replace("export default", "")
        )();

        let opts = {
          ...script,
          template: html,
        };

        // Insertar CSS en el documento
        // const styleElement = document.createElement("style");
        // styleElement.innerHTML = css;
        // document.head.appendChild(styleElement);

        let app = createApp(opts);
        app.config.globalProperties.emitter = emitter;
        emitter.on("*", (type, e) => {
          if (type === "submit") {
            this.perform_submit(e);
          }
        });
        app.mount("#component_wrapper");
        this.dynamic_component = app;
      } catch (error) {
        console.error(error);
        this.error = generate_error_message_text(error);
      }
    },
    perform_submit(data) {
      let v = this;
      console.log("perform_submit", data);
    },
  },
};
</script>

<style scoped>
/* Estilos adicionales si es necesario */
</style>
